import { Component, input, viewChild } from '@angular/core';
import { IColumn } from '@app/shared/interfaces/column.interface';
import { IFiltredDashboardResponse } from '@app/shared/interfaces/dashboard.interface';
import { TableComponent } from '@app/shared/components/table-component/table.component';
import { ExcelButtonComponent } from '@app/shared/components/excel-button/excel-button.component';
import { CardComponent } from '@app/shared/components/card/card.component';

@Component({
    selector: 'app-best-seller-route',
    imports: [TableComponent, ExcelButtonComponent, CardComponent],
    templateUrl: './best-seller-route.component.html',
    styleUrl: './best-seller-route.component.scss'
})
export class BestSellerRouteComponent {
    depPortTemplate = viewChild('depPortTemplate');
    arrPortTemplate = viewChild('arrPortTemplate');

    loading = input<boolean>(false);
    bestSellerRouteData = input<IFiltredDashboardResponse['bestSellerRoute']['results']>();

    cols: IColumn[] = [];

    ngOnInit() {
        this.cols = [
            { key: 'depPort', label: 'Departure', template: this.depPortTemplate() },
            { key: 'arrPort', label: 'Arrival', template: this.arrPortTemplate() },
            { key: 'reservation', label: 'Reservation' },
            { key: 'lastYearReservation', label: "Last Year's Reservation" },
            { key: 'topSellerAgent', label: 'Top Seller Agent' },
            { key: 'revenue', label: 'Revenue' }
        ];
    }

    exportData(): any[] {
        return (
            this.bestSellerRouteData()?.map((item) => ({
                depPort: item.route.depPort ?? '',
                arrPort: item.route.arrPort ?? '',
                reservation: item.reservation ?? '',
                lastYearReservation: item.lastYearReservation ?? '',
                topSellerAgent: item.topSellerAgent ?? '',
                revenue: item.revenue ?? ''
            })) ?? []
        );
    }
}
